import React from 'react';
import { Link } from 'react-router-dom';

import isExternalUrl from 'utils/isExternalUrl';

import SponsorBannerBlock from 'blocks/SponsorBannerBlock';
import { BannerModelType } from 'models/BannerModel';
import { bannerClicks, bannerImpressions } from 'utils/analytics';

interface SponsorBannerProps {
  link: string;
  imagePath: string;
  banner: BannerModelType;
  accountId?: number;
}

export const SponsorBanner = (
  { link, imagePath, banner, accountId }: SponsorBannerProps
) => {

  bannerImpressions(banner.id, banner.title, accountId);


  if (isExternalUrl(link)) {
    return (
      <SponsorBannerBlock>
        <a href={link} target="_blank" rel="noopener" onClick={() => bannerClicks(banner.id, banner.title, link, accountId)}>
          <img src={imagePath} alt="" />
        </a>
      </SponsorBannerBlock>
    );
  } else {
    return (
      <SponsorBannerBlock>
        <Link to={link} onClick={() => bannerClicks(banner.id, banner.title, link, accountId)}>
          <img src={imagePath} alt="" />
        </Link>
      </SponsorBannerBlock>
    );
  }
};

export default SponsorBanner;
